import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import request from '../../helpers/request';
import Widget from './Widget';
import Modal from './Modal';
import NeedsClaim from './NeedsClaim';
import auth0 from '../../helpers/auth0';

var DocumentsCollection = createReactClass({

  getInitialState() {
    return {
      laoding: false,
      documentToDelete: null,
      name: '',
      file: null,
    };
  },

  getDefaultProps(){
    return {
      onDocumentUploaded: () => {},
      onDoumentDeleted: () => {}
    };
  },

  prepareDocumentForDelete(documentToDelete) {
    this.setState({ documentToDelete }, () => this.deleteDocumentModal.show());
  },

  handleDelete() {
    request.del({
      url: this.props.deleteUrlBase + '/' + this.state.documentToDelete.id + '/documents',
      success: () => {
        this.props.onDoumentDeleted(this.state.documentToDelete);
        this.deleteDocumentModal.hide();
        this.setState({documentToDelete: null});
      }
    });
  },

  showDocument(document) {
    const accessToken = auth0.getAccessToken();
    const queryString = '?api_key=' + accessToken;

    const documentUrl = this.props.viewUrlBase +
      '/' + document.id + '/documents' + queryString;

    window.open(documentUrl, '_blank');
  },

  handleUpload(e) {
    e.preventDefault();

    this.setState({loading: true});

    const nameParam = encodeURI(this.state.name);

    const formData = new FormData();

    formData.append('files[0]', this.state.file);

    request.post({
      url: this.props.uploadUrlBase + '/documents?name=' + nameParam,
      data: formData,
      headers: {
      },
      success: data => {
        this.props.onDocumentUploaded(data);
        this.documentUpload.value = '';
        this.setState({
          name: '',
          file: null,
          loading: false,
        });
      }
    });
  },

  render() {
    const dataSelected = !!this.state.name && !!this.state.file;

    if (!this.props.documents) {
      return null;
    }

    const documents = this.props.documents.map(d => (
      <div key={d.id} className="col-md-2 well well-sm bg-color-teal txt-color-white text-center">
        <h5>{d.name}</h5>
        <NeedsClaim claim={this.props.claim}>
          <button
            type="button"
            className="btn btn-danger btn-xs"
            onClick={() => this.prepareDocumentForDelete(d)}
          >
            Löschen
          </button>&nbsp;
        </NeedsClaim>
        <button
          type="button"
          className="btn btn-primary btn-xs"
          onClick={() => this.showDocument(d)}
        >
          Download
        </button>
      </div>
    ));

    return (
      <Widget title="Dokumente" icon="file" containerClassName="col-md-12">
        <div className="chat-body custom-scroll">
          {documents}
        </div>
        <NeedsClaim claim={this.props.claim}>
          <div className="chat-footer">
            <form>
              <div className="textarea-div">
                <div className="typearea">
                  <div className="row">
                    <div className="col-md-4">
                      <input
                        type="text"
                        value={this.state.name}
                        placeholder="Name..."
                        className="form-control"
                        style={{
                          border: this.state.name ? 'none' : '1px solid #b94a48',
                          backgroundColor: this.state.name ? 'white' : '#fff0f0'
                        }}
                        onChange={e => this.setState({name: e.target.value})} />
                    </div>
                    <div className="col-md-8">
                      <input
                        type="file"
                        name="file"
                        accept="application/pdf"
                        onChange={e => this.setState({file: e.target.files[0]})}
                        ref={c => this.documentUpload = c}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <span className="textarea-controls">
                {this.state.loading &&
                  <i className="fa fa-gear fa-2x fa-spin pull-right" />
                }
                {!this.state.loading &&
                  <button
                    disabled={!dataSelected}
                    className="btn btn-sm btn-primary pull-right"
                    onClick={this.handleUpload}
                    type="submit"
                  >
                    Upload
                  </button>
                }
                <span className="pull-right smart-form" style={{marginTop: 3, marginRight: 10}}></span>
              </span>
            </form>
          </div>
        </NeedsClaim>
        {this.state.documentToDelete &&
          <Modal
            ref={c => this.deleteDocumentModal = c}
            title="Dokument löschen?"
            message={` Sind Sie sicher, dass Sie das Dokument '${this.state.documentToDelete.name}' löschen wollen??`}
            confirmButtonText="Ja, löschen"
            onConfirm={this.handleDelete}
          />
        }
      </Widget>
    );
  }
});

DocumentsCollection.propTypes = {
  documents: PropTypes.array.isRequired,
  onDocumentUploaded: PropTypes.func.isRequired,
  onDoumentDeleted: PropTypes.func.isRequired,
  deleteUrlBase: PropTypes.string.isRequired,
  viewUrlBase: PropTypes.string.isRequired,
  uploadUrlBase: PropTypes.string.isRequired,
  claim: PropTypes.string.isRequired,
};
export default DocumentsCollection;



// WEBPACK FOOTER //
// ./src/components/common/DocumentsCollection.js